import { render } from "./MyGallery.vue?vue&type=template&id=1a9fca29"
import script from "./MyGallery.vue?vue&type=script&lang=js"
export * from "./MyGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__